import * as yup from 'yup'

const AiChatSettingsSchema = yup.object().shape({
  baseUrl: yup
    .string()
    .required('aiSettings.errors.baseUrl.required')
    .max(2048, 'aiSettings.errors.baseUrl.max')
    .matches(/^https?:\/\/\S+$/, 'aiSettings.errors.baseUrl.invalid'),
  apiKey: yup
    .string()
    .max(4096, 'aiSettings.errors.apiKey.max')
    .matches(/^[\x21-\x7E]*$/, 'aiSettings.errors.apiKey.invalidCharacters'),
  clearApiKey: yup.boolean(),
})

export { AiChatSettingsSchema }
